import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { URL } from '../../environments/environment';

export interface IInvoice {

}

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient
  ) { }

  public findInvoice(formData) {
    const url = URL.FIND_INVOICE;
    return this.http.post(url, formData);
  }
}
